import axios from 'axios';
import { config } from '@/helpers/variables';
import { API_URL } from '@/helpers/variables';

export const reviewService = {
  async postReview(data: object) {
    const API_POST_URL = `${API_URL}satellite/reviews/`;
    config;

    axios
      .post(API_POST_URL, data, config)
      .then((res) => {
        // console.log('RESPONSE ==== : ', res);
      })
      .catch((err) => {
        console.log('ERROR: ====', err);
      });
  },
  async postCollectionReview(data: object) {
    const API_POST_URL = `${API_URL}satellite/collections/addreview/`;
    config;
    axios
      .post(API_POST_URL, data, config)
      .then((res) => {})
      .catch((err) => {
        console.log('ERROR: ====', err);
      });
  },
};
